import { RoleName, User, UserImpl, UserJSONObject } from "@utils/User/User";
import { CustomerData } from "@utils/Customer/Customer";
import { RetailerData } from "@utils/Retailer/RetailerRepository";
import { CountryName } from "@utils/Localization/Country/countryEnums";
import { Address } from "@utils/Address/Address";
import { UserData } from "@utils/User/interfaces";

export interface CreateUserData {
  username?: string;
  email?: string | undefined;
  phoneNumber?: string;
  password: string;
  name: string;
  country?: CountryName;
  addresses?: Address[];
  company?: string;
  subscribeToNewsletter?: boolean;
}

// TODO remove this file
export const strapiUserToUserJSONObject = (userData: UserData) => {
  const newUser = new UserImpl({
    id: userData.id,
    username: userData.username,
    email: userData.email,
    phoneNumber: userData.phoneNumber,
    name: userData.name,
    company: userData.company,
    role: {
      name: userData.role?.name || RoleName.User
    },
    blocked: userData.blocked,
    country: userData.country,
    customer: userData.customer as CustomerData,
    defaultRetailer: userData.defaultRetailer as RetailerData
  });

  return newUser.toJSON();
};

export const createUserFromStrapiUser = (userData: UserJSONObject): User => {
  return new UserImpl({
    id: userData.id,
    username: userData.username,
    email: userData.email,
    phoneNumber: userData.phoneNumber,
    name: userData.name,
    company: userData.company,
    role: {
      name: userData.role
    },
    blocked: userData.blocked,
    country: userData.country,
    customer: userData.customer as CustomerData,
    defaultRetailer: userData.defaultRetailer as RetailerData
  });
};
